import { createFileRoute } from '@tanstack/react-router';

import { MyLandEnquiriesPage } from '@/features/land/my-enquiries-page';

export const Route = createFileRoute('/_app/land/enquiries')({ component: MyLandEnquiriesPage });
